export default __webpack_public_path__ + "static/media/icon-municipality.fa8b8261.svg";